import { Outlet,useLoaderData,redirect,useNavigation } from "react-router-dom";
import { getContacts, createContact } from "../contacts";
// import { useEffect } from "react";
import Header from "../components/Header";
import style from "../styles/head.module.css";

export async function action() {
    const contact = await createContact();
    return redirect(`/contacts/${contact.id}/edit`);
  }

  export async function loader({ request }) {
    const url = new URL(request.url);
    const q = url.searchParams.get("q");
    const contacts = await getContacts(q);
    return { contacts, q };
  }

export default function Root() {
    const { contacts, q } = useLoaderData();
    console.log('q: ', q);
    console.log('contacts: ', contacts);
    const navigation = useNavigation();
//    const submit = useSubmit();

/*    useEffect(() => {
        document.getElementById("q").value = q;
      }, [q]);
*/
    const searching =
    navigation.location &&
    new URLSearchParams(navigation.location.search).has(
    "q"
    );


    return (
      <div className={style.page}>
            <Header />
        <div id="detail">
            <Outlet />
        </div>
      </div> 
    );
  }